import {
  Image, Stack,
  Box,
  CloseButton
} from '@chakra-ui/react'
import Carousel from 'react-multi-carousel'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { markersSelectors, toggleImageCarousel } from 'store'
import { motion } from 'framer-motion'
import { LeftButtonIcon } from './Buttons/LeftButton'
import { RightButtonIcon } from './Buttons/RightButton'

export const ImageCarouselModal = () => {
  let imageIndex = localStorage.getItem('image-current-slide')

  const carouselContainerRef = useRef()
  const carouselRef = useRef()
  const carouselItemRefs = useRef([])
  const { eventData } = useSelector(markersSelectors)
  const [activeIndex, setActiveIndex] = useState(0)
  const [justOpened, setJustOpened] = useState(true)
  const { imageNaturalWidths } = useSelector(markersSelectors)
  const dispatch = useDispatch()
  // console.log(imageNaturalWidths)

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  }

  // functions
  const handleBeforeChange = (nextSlide, { currentSlide }) => {
    if (justOpened === true) {
      setActiveIndex(currentSlide)
      setTimeout(() => setJustOpened(false), 1000)
    } else {
      setActiveIndex(nextSlide)
      localStorage.setItem('image-carousel-display', nextSlide)
    }
  }

  const goTo = (index) => {
    if (carouselRef.current) {
      carouselRef.current?.goToSlide(index, false)
      setActiveIndex(index)
    }
  }

  const addToRefs = (el) => {
    if (el && !carouselItemRefs?.current.includes(el)) {
      carouselItemRefs?.current.push(el)
    }
  }

  // output
  return (
    <Stack
      className="carousel-wrapper"
      zIndex={400}
      sx={{
        width: '100vw',
        height: '92.5vh',
        position: 'absolute',
        top: 0,
        zIndex: 9999,
        justifyContent: 'center',
        alignItems: 'center',
        '@media screen and (max-width: 1024px)': {
          height: '88vh'
        }
      }}
      onLoad={() => goTo(+imageIndex)}
      onClick={() => dispatch(toggleImageCarousel(false))}
    >
      <Stack
        ref={carouselContainerRef}
        className="carousel-container"
        as={motion.div}
        animate={{
          height: carouselItemRefs?.current[activeIndex]?.height + 12,
          duration: 0.5
        }}
        transition="0.1s linear"
        zIndex={402}
        height={carouselItemRefs?.current[activeIndex]?.height + 12}
        // width={carouselItemRefs?.current[activeIndex]?.naturalWidth * 1.5 || '25vw'}
        width="50vw"
        maxWidth="30vw"
        marginBlock="6%"
        sx={{
          '@media screen and (max-width: 1024px)': {
            maxWidth: '100%',
            width: '100%',
            marginBlock: '6%'
          }
          // '@media (width: 2064px), (width: 2048px), (height: 2752px), (width: 2732px),': {
          //   maxWidth: '100%',
          //   width: '100%',
          //   marginBlock: '6%'
          // }
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <Carousel
          itemClass="carousel-item-no-gap"
          slidesToSlide={1}
          responsive={responsive}
          swipeable
          draggable
          beforeChange={handleBeforeChange}
          minimumTouchDrag={20}
          ref={carouselRef}
          customLeftArrow={<LeftButtonIcon />}
          customRightArrow={<RightButtonIcon />}
        >
          {eventData?.additional_images.map((e) => (
            <Box
              width="100%"
              height="auto"
              // maxWidth="30vw"
              maxHeight="80vh"
              overflowY="auto"
              sx={{
                '.element::-webkit-scrollbar': {
                  display: 'none'
                },
                scrollbarWidth: 'none',
                '-ms-overflow-style0': 'none',
                borderRadius: '5px',
                border: '5px solid white',
                boxShadow: '5px 5px 5px #333333ff',
                '@media screen and (max-width: 1024px)': {
                  width: '100vw',
                  maxHeight: '80vh'
                }
                // '@media (width: 2064px), (width: 1668px), (height: 2752px), (width: 2420px),': {
                //   width: '100vw',
                //   maxHeight: '80vh'
                // }
              }}
            >
              <CloseButton
                className="close-carousel-button"
                onClick={() => dispatch(toggleImageCarousel(false))}
                sx={{
                  position: 'absolute',
                  display: 'inline',
                  zIndex: 405,
                  alignSelf: 'start',
                  right: '10px',
                  marginEnd: '10px',
                  marginBlockStart: '10px',
                  color: 'white',
                  borderRadius: 'full',
                  mixBlendMode: 'difference',
                  border: '2px solid white',
                  '@media screen and (max-width: 1024px)': {
                    display: 'inline'
                  }
                }}
              />
              <Image
                ref={addToRefs}
                src={e}
                draggable={false}
                sx={{
                  width: '100%',
                  '@media screen and (max-width: 1024px)': {
                    objectFit: 'fill',
                    width: '100vw'
                  }
                }}
              />
            </Box>
          ))}
        </Carousel>
      </Stack>
    </Stack>
  )
}
